<app-sprintpay-header
    [showFacilityInformation]="showFacilityInformation"
    [administrativeLoginURL]="administrativeLoginURL"
    [homeURL]="homeURL"
    [cartDisallowedRoutes]="cartDisallowedRoutes"
    [loginDisallowedRoutes]="loginDisallowedRoutes"
    [widthLogo]="widthLogo"
>
    <ng-content></ng-content>
</app-sprintpay-header>
